/**
 * The hour the morning summary really arrives when the night of « Ne pas
 * déranger » ends after the chosen hour (the server makes it wait for the end
 * of the night); null when it arrives at the chosen hour or is off.
 */
export const digestDelayedUntil = (settings: {
  morningDigest: string
  quietHours: string
}): number | null => {
  if (settings.morningDigest === 'off' || settings.quietHours === 'off') return null
  const nightEnd = Number(settings.quietHours.split('-')[1])
  return Number(settings.morningDigest) < nightEnd ? nightEnd : null
}
